import axios, { AxiosError } from "axios";
import api from "./Api";
const PICKLIST_URL = process.env.REACT_APP_PICKLIST_URL || "";
//const DR_SCHEDULE_URL = process.env.REACT_APP_SCHEDULE_URL || "";
const SummaryReport_URL = process.env.REACT_APP_CASE_URL || "";
const SummaryReport = api(SummaryReport_URL);
const DR_SCHEDULE_URL1 = api(PICKLIST_URL);
const dr_schedule1 = api(PICKLIST_URL);
const safeParse = (jsonString: string | null): any[] => {
  try {
    return jsonString ? JSON.parse(jsonString) : [];
  } catch (e) {
    console.error("Failed to parse JSON:", jsonString, e);
    return [];
  }
};

export const FetchCaseSummaryDetails = async (
  caseInfoId: number
): Promise<any> => {
  try {
    const response = await SummaryReport.get(
      `/api/case/information/summary?caseinfoid=${caseInfoId}`
    );

    const data = response.data;

    if (!data?.result || typeof data.result !== "object") {
      throw new Error("Invalid API response: Expected an object in 'result'.");
    }
    const safeParse = (jsonString: string | null): any[] => {
      try {
        return jsonString ? JSON.parse(jsonString) : [];
      } catch (error) {
        return [];
      }
    };
    const parsedResult = {
      caseInfoId: data.result.caseInfoId,
      caseName: data.result.caseName,
      caseId: data.result.caseId,
      priorityName: data.result.priorityName,
      caseReviewTypeName: data.result.caseReviewTypeName,
      claimNumber: data.result.claimNumber,
      wcabNumber: data.result.wcabNumber,
      panelNumber: data.result.panelNumber,
      fileNumber: data.result.fileNumber,
      caseNumber: data.result.caseNumber,
      additionalComments: data.result.additionalComments,
      caseStageName: data.result.caseStageName,
      dateOfRegistration: data.result.dateOfRegistration,
      createdByName: data.result.createdByName,
      createdDate: data.result.createdDate,
      caseSubjectAka: data.result.caseSubjectAka,
      subjectFullName: data.result.subjectFullName,
      caseSubjectDob: data.result.caseSubjectDob,
      caseSubjectGenderDesc: data.result.caseSubjectGenderDesc,
      caseSubjectSsn: data.result.caseSubjectSsn,
      caseSubjectAddress: data.result.caseSubjectAddress,
      caseSubjectEmailAddress: data.result.caseSubjectEmailAddress,
      caseSubjectPhoneNumber: data.result.caseSubjectPhoneNumber,
      caseSubjectFaxNumber: data.result.caseSubjectFaxNumber,
      managedByTeam: data.result.managedByTeam,
      clientName: data.result.clientName,
      clientAddress: data.result.clientAddress,
      clientPhoneNumber: data.result.clientPhoneNumber,
      employerEntityName: data.result.employerEntityName,
      employerAddress: data.result.employerAddress,
      empStkAddressPhoneNumber: data.result.empStkAddressPhoneNumber,
      empStkAddressFaxNumber: data.result.empStkAddressFaxNumber,
      applicantAttorneyName: data.result.applicantAttorneyName,
      applicantAttorneyAddress: data.result.applicantAttorneyAddress,
      applicantAttorneyPhoneNumber: data.result.applicantAttorneyPhoneNumber,
      applicantAttorneyFaxNumber: data.result.applicantAttorneyFaxNumber,
      applicantAttorney: safeParse(data.result.applicantAttorneyJson),
      defenceAttorneyName: data.result.defenceAttorneyName,
      defenceAttorneyAddress: data.result.defenceAttorneyAddress,
      defenceAttorneyPhoneNumber: data.result.defenceAttorneyPhoneNumber,
      serviceProviderName: data.result.serviceProviderName,
      serviceProviderAddress: data.result.serviceProviderAddress,
      serviceProviderPhoneNumber: data.result.serviceProviderPhoneNumber,
      serviceProviderFaxNumber: data.result.serviceProviderFaxNumber,
      managedByTeamHodName: data.result.managedByTeamHodName,
      teamHodPhone: data.result.teamHodPhone,
      teamHodEmailId: data.result.teamHodEmailId,
      teamHodFax: data.result.teamHodFax,
      insuranceAdminName: data.result.insuranceAdminName,
      insuranceAdminAddress: data.result.insuranceAdminAddress,
      insuranceAdminPhoneNumber: data.result.insuranceAdminPhoneNumber,
      insuranceAdminFaxNumber: data.result.insuranceAdminFaxNumber,
      adjNumber: data.result.adjNumber,
      // Safe parsed arrays
      injuries: safeParse(data.result.injuriesJson),
      appointments: safeParse(data.result.appointmentsJson),
      clientJson: safeParse(data.result.clientJson),
      employerJson: safeParse(data.result.employerJson),
      serviceProviderJson: safeParse(data.result.serviceProviderJson),
      defenceAttorneyJson: safeParse(data.result.defenceAttorneyJson),
      insuranceAdminJson: safeParse(data.result.insuranceAdminJson),
      generatedBy : data.result.generatedBy,
      logo: data.result?.logo || "",
    };

    return { isSuccess: data.isSuccess, result: parsedResult };
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      console.error("API Error:", error.response?.data || error.message);
      throw new Error(
        error.response?.data?.message ||
          "Unable to fetch case summary. Please try again."
      );
    } else {
      console.error("Unexpected Error:", error);
      throw new Error("An unexpected error occurred. Please try again.");
    }
  }
};
